// frontend/src/services/productTour.js
//
// First-login onboarding tour (driver.js). Walks a new user through the
// dashboard sections top to bottom. Steps whose anchor element isn't on the
// page (e.g. a rail still loading) are skipped automatically.
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

const TOUR_SEEN_KEY = 'theleaf_tour_seen_v1';

const STEPS = [
  {
    element: '#tour-strip',
    popover: {
      title: 'Market health at a glance',
      description: 'Four quick reads on this stock: trend (moving averages), momentum (RSI), volume flow (OBV), and how buying monthly would have compared to a bank deposit. The tag under each mini-chart shows how well that textbook rule actually worked on this stock.',
    },
  },
  {
    element: '#tour-seasonal',
    popover: {
      title: 'Seasonal tendency',
      description: 'Average daily return by calendar bucket — day of week, month, quarter and more. The blue bar is where we are right now, and the % is how often that bucket closed up historically.',
    },
  },
  {
    element: '#tour-chart',
    popover: {
      title: 'The main chart',
      description: 'Candlesticks with the ION trend line, entry / take-profit / stop signals, and the Matching projection — a band built from the most similar historical episodes. Switch timeframes and toggle indicators in the toolbar above the chart.',
    },
  },
  {
    element: '#tour-regime',
    popover: {
      title: 'Regime Intelligence',
      description: 'A statistical model of the market state: the current regime (bull / sideways / bear) with its probability, the latent trend, and market-quality metrics like noise and volatility.',
    },
  },
  {
    element: '#tour-pair',
    popover: {
      title: 'Pair trading',
      description: 'Ed Thorp-style pair trading: pick a second symbol and we check cointegration, backtest the z-score spread strategy, and chart both legs with entry signals.',
    },
  },
  {
    popover: {
      title: 'One last tip',
      description: 'Every card has a small ⓘ icon — hover or tap it any time for a plain-language explanation of what the card shows and how to read it. Enjoy!',
    },
  },
];

export const hasSeenTour = () => {
  try { return localStorage.getItem(TOUR_SEEN_KEY) === '1'; } catch (e) { return true; }
};

export const markTourSeen = () => {
  try { localStorage.setItem(TOUR_SEEN_KEY, '1'); } catch (e) { /* private mode */ }
};

export const startProductTour = () => {
  // Only keep steps whose anchor exists right now (plus the anchorless outro).
  const steps = STEPS.filter((s) => !s.element || document.querySelector(s.element));
  if (steps.length === 0) return;
  markTourSeen();
  const d = driver({
    showProgress: true,
    overlayOpacity: 0.55,
    stagePadding: 6,
    nextBtnText: 'Next →',
    prevBtnText: '← Back',
    doneBtnText: 'Done',
    steps,
  });
  d.drive();
};
